module.exports = __webpack_public_path__ + "img/ricoh.c342c40d.png";